export enum CalculationLeadStatusEnum {
  UnverifiedCold = 'unverifiedCold',
  Cold = 'cold',
  UnverifiedWarm = 'unverifiedWarm',
  Warm = 'warm',
  UnverifiedHot = 'unverifiedHot',
  Hot = 'hot',
  Migrated = 'migrated',
}
